import { render, staticRenderFns } from "./waybills.vue?vue&type=template&id=367e77f6&scoped=true&"
import script from "./waybills.vue?vue&type=script&lang=js&"
export * from "./waybills.vue?vue&type=script&lang=js&"
import style0 from "./waybills.vue?vue&type=style&index=0&id=367e77f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367e77f6",
  null
  
)

export default component.exports